import React from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';

import logo from './assets/logo.png';
import './App.css';

// Import your pages
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import Services from './pages/Services';
import Team from './pages/Team';
import Contact from './pages/Contact';
import Projects from './pages/Projects';

import ProjectDetail from "./pages/ProjectDetail";
import Partners from './pages/Partners';

import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';

import WorkWithUs from "./pages/WorkWithUs";



import Navbar from './components/Navbar';
import Footer from './components/Footer';

import ScrollToTopButton from "./components/ScrollToTopButton";
import ScrollToTopOnLoad from "./components/ScrollToTopOnLoad";

import TestApi from "./pages/TestApi";

function LandingPage() {
  const navigate = useNavigate();

  const handleExploreClick = () => {
    const button = document.querySelector(".explore-btn");
    if (button) {
      button.classList.add("jump");
      setTimeout(() => {
        navigate("/home");
      }, 500);
    }
  };

  return (
    <div className="App landing-page">
      <header className="App-header" onClick={handleExploreClick}>
        <img src={logo} className="App-logo" alt="logo" />
        <p></p>

        {/* ✨ Pulsing round arrow button */}
        <button className="explore-btn w3-black" onClick={handleExploreClick}>
          <span className="arrow">&#x2193;</span>
        </button>
      </header>
    </div>
  );
}


// ✅ Wrap everything inside <Router>
function App() {
  return (
    <Router>
     <ScrollToTopOnLoad /> 
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route
          path="/home"
          element={
            <>
              <Navbar />
              <Home />
              <Footer />
            </>
          }
        />
        <Route
          path="/aboutus"
          element={
            <>
              <Navbar />
              <AboutUs />
              <Footer />
            </>
          }
        />
        <Route
          path="/services"
          element={
            <>
              <Navbar />
              <Services />
              <Footer />
            </>
          }
        />
        <Route
          path="/team"
          element={
            <>
              <Navbar />
              <Team />
              <Footer />
            </>
          }
        />
        <Route
          path="/contact"
          element={
            <>
              <Navbar />
              <Contact />
              <Footer />
            </>
          }
        />

         <Route
          path="/test-api"
          element={
            <>
              <Navbar />
              <TestApi />
              <Footer />
            </>
          }
        />

        <Route
          path="/projects"
          element={
            <>
              <Navbar />
              <Projects />
              <Footer />
            </>
          }
        />

         <Route
          path="/projects/:id"
          element={
            <>
              <Navbar />
              <ProjectDetail />
              <Footer />
            </>
          }
        />

         <Route
          path="/partners"
          element={
            <>
              <Navbar />
              <Partners />
              <Footer />
            </>
          }
        />

        <Route
  path="/workwithus"
  element={
    <>
      <Navbar />
      <WorkWithUs />
      <Footer />
    </>
  }
/>


         <Route
          path="/terms"
          element={
            <>
              <Navbar />
              <Terms />
              <Footer />
            </>
          }
        />

         <Route
          path="/privacy-policy"
          element={
            <>
              <Navbar />
              <PrivacyPolicy />
              <Footer />
            </>
          }
        />

      </Routes>
        <ScrollToTopButton />  
    </Router>
  );
}

export default App;
